import { useState } from 'react';
import './About.scss';
import cn from 'classnames';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { useNavigate } from 'react-router-dom';
import MainScreen from '../../components/MainScreen';
import PreFooter from '../../components/PreFooter';
import Back from './bg.jpg';
import Popup from '../../components/Popup';

const MainPage = () => {
  const navigate = useNavigate();
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  return (
    <div className='page'>
      <Header />
      <MainScreen
        background={Back}
        beforeTags={['Inc. 5000 Fastest Growing Company']}
        title='YOUR TRUSTED STAFFING PARTNER'
        text='National healthcare recruiting firm specializing in interim and permanent executive placements with over 50 years of combined expertise'
        onMainClick={() => setIsPopupOpen(true)}
      />

      <div className='aboutStatsSection'>
        <div className='aboutStats'>
          <div className='aboutStat'>
            <span className='aboutStatCount'>30+</span>
            <span className='aboutStatText'>Years in Business</span>
          </div>
          <div className='aboutStat'>
            <span className='aboutStatCount'>1000+</span>
            <span className='aboutStatText'>Successful Placements</span>
          </div>
          <div className='aboutStat'>
            <span className='aboutStatCount'>50+</span>
            <span className='aboutStatText'>States Served</span>
          </div>
          <div className='aboutStat'>
            <span className='aboutStatCount'>24/7</span>
            <span className='aboutStatText'>Client Support</span>
          </div>
        </div>
      </div>

      <div className='articleSection'>
        <span className='blockTitle'>Our Story</span>
        <span className='blockText'>
          Built on principles of integrity, excellence, and genuine partnership in healthcare staffing.
        </span>
        <div className='articleContent'>
          <span className='articleText'>
            American Consultants has experienced tremendous growth, earning recognition as one of the nation's fastest-growing
            companies. This success stems from our unwavering commitment to the principles that guide every interaction and
            decision. We truly understand the pulse of healthcare and are committed to providing comprehensive staffing solutions
            with a personal touch.
          </span>
          <span className='articleText'>
            Our clients range from large healthcare systems to rural hospitals, from clinics to laboratories, and from clinical
            research organizations to healthcare IT providers. At American Consultants, we don't want to be just an agency you
            hire; we genuinely want to partner with our clients to fulfill their short-term and long-term goals while delivering
            unparalleled customer service every step of the way.
          </span>
        </div>
      </div>

      <div className='quote'>
        <span className='quoteText'>
          For those who are new to American Consultants, thank you for visiting our website to learn more about us. We would love
          to partner with you in achieving your staffing and talent acquisition goals.
          <br />
          <br />
          To our existing customers: thank you for your continued loyalty and support. We remain committed to serving you.
          <br />
          <br />
          American Consultants doesn’t want to be just an agency you hire; we genuinely want to partner with our clients to
          fulfill their short-term and long-term goals. We strive to deliver unparalleled customer service every step of the way.
          Whether you are a healthcare organization looking to hire, a candidate looking for a new position, or a consultant
          looking for your next engagement, we welcome the opportunity to work with you.
        </span>
        <span className='quoteAuthor'>Marty Fitzgerald</span>
        <span className='quoteAddress'>President, American Consultants</span>
      </div>

      <div className='pointsSection'>
        <span className='blockTitle'>OUR PROMISES TO YOU</span>
        <span className='blockText'>Commitments that set us apart in healthcare recruiting and ensure your success.</span>

        <div className='points' style={{ flexWrap: 'wrap' }}>
          <div className='pointItem' style={{ paddingTop: '32px' }}>
            <span className='pointItemTitle' style={{ color: '#F39B38' }}>
              Flexibility
            </span>
            <span className='pointItemText'>
              Diverse mix of healthcare staffing services that adapt and evolve to meet the changing needs of the healthcare
              industry.
            </span>
            <span className='pointItemIcon'></span>
          </div>

          <div className='pointItem' style={{ paddingTop: '32px' }}>
            <span className='pointItemTitle' style={{ color: '#F39B38' }}>
              Competitive Pricing
            </span>
            <span className='pointItemText'>
              Attentive service at the most competitive pricing without compromising on quality or results.
            </span>
            <span className='pointItemIcon'></span>
          </div>

          <div className='pointItem' style={{ paddingTop: '32px' }}>
            <span className='pointItemTitle' style={{ color: '#F39B38' }}>
              Concierge-Level Care
            </span>
            <span className='pointItemText'>
              Personal attention through every step, handling all big and small details from beginning to successful completion.
            </span>
            <span className='pointItemIcon'></span>
          </div>

          <div className='pointItem' style={{ paddingTop: '32px' }}>
            <span className='pointItemTitle' style={{ color: '#F39B38' }}>
              Healthcare Expertise
            </span>
            <span className='pointItemText'>
              50+ years of combined experience in healthcare-specific staffing and executive search with proven processes.
            </span>
            <span className='pointItemIcon'></span>
          </div>

          <div className='pointItem' style={{ paddingTop: '32px' }}>
            <span className='pointItemTitle' style={{ color: '#F39B38' }}>
              Nationwide Network
            </span>
            <span className='pointItemText'>
              Real-time database of healthcare professionals updated daily, with access to both active and passive candidates.
            </span>
            <span className='pointItemIcon'></span>
          </div>

          <div className='pointItem' style={{ paddingTop: '32px' }}>
            <span className='pointItemTitle' style={{ color: '#F39B38' }}>
              Risk Mitigation
            </span>
            <span className='pointItemText'>
              Proven ability to identify red flags, ask tough questions, and ensure both candidates and clients make informed
              decisions.
            </span>
            <span className='pointItemIcon'></span>
          </div>
        </div>
      </div>

      {!!isPopupOpen && <Popup onClose={() => setIsPopupOpen(false)} />}

      <PreFooter
        title='Ready to Partner With Us?'
        text="Whether you're seeking exceptional talent or looking for your next career opportunity, we're here to make it happen"
        mainButtonText='Schedule Consultation'
        onMainClick={() => setIsPopupOpen(true)}
      />
      <Footer />
      {/* {isFormOpen && <Form onClose={() => setFormOpen(false)} />} */}
    </div>
  );
};

export default MainPage;
